import createAsyncSlice from '../utils/createAsyncSlice';

const warehouseContact = createAsyncSlice({
  name: 'warehouseContact',
  initialState: {
    data: [],
  },
});

export const fetchWarehouseContact = warehouseContact.asyncAction;
export const httpRequestWarehouseContact = warehouseContact.httpRequest;
export const { resetState: resetWarehouseContactState } =
  warehouseContact.actions;
export default warehouseContact.reducer;
